import react, {useEffect} from 'react'
import './style.css'
import {ScanInputTextarea} from './ScanInputTextarea';
import {TextareaWidgets} from './TextareaWidgets';
import {TextareaControll} from './TextareaControll';
import {ScanContainer} from './ScanContainer';
import {ResultContainer} from './ResultContainer';
import {PlagiarismModal} from 'elements/fileDrop/PlagiarismModal';
import {PermissionGuardModal} from '../PermissionGuardModal';
import {useNavigate} from "react-router";
import {useStores} from "../../stores/root";
import {observer} from "mobx-react-lite";

export const ScanTextPanel: react.FC = observer(() => {

    const {plagiarism, input} = useStores()
    const navigate = useNavigate();


    useEffect(() => {
        const listener = function (event: KeyboardEvent) {
            const ta = document.getElementById('textarea')
            if (document.activeElement === ta) {
                return;
            }
            if ((event.metaKey && event.key === 'v') || (event.ctrlKey && event.key === 'v')) {
                navigator.clipboard.readText().then((e) => {
                    input.setText(input.text + e);
                });
            }
        }
        document.addEventListener('keydown', listener);
        if (!input.text.split('\n').join('').length) {
            input.setSegments('');
        }
        return () => {
            document.removeEventListener('keydown', listener)
        }
    }, [input.text]);

    return <div className='uploader__container'>
        <PlagiarismModal
            isOpen={plagiarism.activeGroup !== null}
            onClose={() => plagiarism.setActiveGroup(null)}
        />
        <PermissionGuardModal open={input.showPlanUpgradeTooltip} onClose={() => {
            input.setShowPlanUpgradeTooltip(false);
        }} onUpgrade={() => {
            navigate('/main/subscription');
        }}
                              alertText={"Uploading docuemnts is a premium feature."}
        />
        <div>
            <ScanInputTextarea/>
            {
                input.text.length === 0 &&
                <TextareaWidgets/>
            }
            <TextareaControll/>
            <ScanContainer/>
        </div>
        <ResultContainer/>
    </div>
})